import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { TemplateForm } from "@/components/templates/TemplateForm";
import { Button } from "@/components/ui/button";

export function TemplateDetailPage() {
  const { templateId } = useParams({ strict: false });
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Edit Template"
        actions={
          <Button variant="outline" onClick={() => navigate({ to: "/dashboard/templates" })}>
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Templates
          </Button>
        }
      />
      <TemplateForm templateId={templateId} />
    </div>
  );
}
